import { Component, OnInit, ChangeDetectorRef, inject } from '@angular/core';
import { CadastroService } from '../../../../services/cadastro.service';
import { Fornecedor } from '../../../../models/cadastro.model';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ErrorModel } from '../../../../models/error.model';
import { ToastrService } from 'ngx-toastr';
import { NgxMaskPipe } from 'ngx-mask';

@Component({
  selector: 'app-fornecedores',
  standalone: true,
  imports: [CommonModule, FormsModule, NgxMaskPipe],
  templateUrl: './fornecedores.component.html',
  styleUrls: ['./fornecedores.component.css']
})
export class FornecedoresComponent implements OnInit {
  fornecedores: Fornecedor[] = [];
  filteredFornecedores: Fornecedor[] = [];
  paginatedFornecedores: Fornecedor[] = [];
  
  currentPage = 1;
  itemsPerPage = 10;
  totalPages = 1;
  maxPagesToShow = 5;
  startPage!: number;
  endPage!: number;
  pages: number[] = [];

  searchTerm = '';

  constructor(
    private cadastroService: CadastroService, 
    private router: Router,
    private toastr: ToastrService
  ) { }
  
  private cdr = inject(ChangeDetectorRef);

  ngOnInit(): void {
    this.loadFornecedores();
  } 

  loadFornecedores(): void {
    this.cadastroService.getFornecedores().subscribe(data => {
      this.fornecedores = data;
      this.filteredFornecedores = data;
      this.totalPages = Math.max(1, Math.ceil(this.filteredFornecedores.length / this.itemsPerPage));
      this.setPage(1);
      this.cdr.detectChanges();
    });
  }

  search(): void {
    this.filteredFornecedores = this.fornecedores.filter(fornecedor =>
      fornecedor.razaoSocial.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
      fornecedor.nomeFantasia.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
      fornecedor.cnpj.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
    this.totalPages = Math.max(1, Math.ceil(this.filteredFornecedores.length / this.itemsPerPage));
    this.setPage(1);
  }

  setPage(page: number): void {
    if (page < 1 || page > this.totalPages) {
      return;
    }
    this.currentPage = page;
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = Math.min(startIndex + this.itemsPerPage, this.filteredFornecedores.length);
    this.paginatedFornecedores = this.filteredFornecedores.slice(startIndex, endIndex);
    this.updatePageNumbers();
  }

  updatePageNumbers(): void {
    const halfPages = Math.floor(this.maxPagesToShow / 2);
    this.startPage = Math.max(1, this.currentPage - halfPages);
    this.endPage = Math.min(this.totalPages, this.startPage + this.maxPagesToShow - 1);

    if (this.endPage - this.startPage + 1 < this.maxPagesToShow) {
      this.startPage = Math.max(1, this.endPage - this.maxPagesToShow + 1);
    }

    this.pages = Array.from(
      { length: (this.endPage - this.startPage) + 1 },
      (_, i) => this.startPage + i
    );
  }

  novoFornecedor(): void {
    this.router.navigate(['/home', 'cadastro-fornecedor-manutencao']);
  }

  editarFornecedor(id: number): void {
    this.router.navigate(['/home', 'cadastro-fornecedor-manutencao', id]);
  }

  deleteFornecedor(id: number): void {
     this.cadastroService.deleteFornecedor(id).subscribe({
       next: () => {
         this.loadFornecedores();
         this.toastr.success('Fornecedor excluído com sucesso!');
       },
       error: (error) => {
         var erro: ErrorModel = error.error;
         this.toastr.error(erro.message);
       }});
  }
}
